import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { SP360Logo } from 'assets';

import { redirectToLogin } from '../../lib/auth';
import axios from '../../lib/axiosInstance';

function renderNotification() {
  return (
    <ToastContainer
      position="bottom-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
    />
  );
}

const PREFIX = 'ChangeMFA';

const classes = {
  paper: `${PREFIX}-paper`,
  avatar: `${PREFIX}-avatar`,
  form: `${PREFIX}-form`,
  submit: `${PREFIX}-submit`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.paper}`]: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  [`& .${classes.avatar}`]: {
    margin: theme.spacing(1),
    backgroundColor: '#FFFFFF',
    height: '60px',
    width: '60px',
  },
  [`& .${classes.form}`]: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  [`& .${classes.submit}`]: {
    margin: theme.spacing(3, 0, 2),
  },
}));

function ChangeMFA() {
  const [isMfaReset, setIsMfaReset] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const [email, setEmail] = useState('');
  const [maskedEmail, setMaskedEmail] = useState('');

  useEffect(() => {
    let mfa_email = window.location.search.split('mfa_email=');
    if (mfa_email.length > 1) {
      mfa_email = window.location.search.split('mfa_email=')[1].split('&')[0];
      setEmail(decodeURIComponent(mfa_email));
    }
    let masked_email = window.location.search.split('masked_email=');
    if (masked_email.length > 1) {
      masked_email = window.location.search
        .split('masked_email=')[1]
        .split('&')[0];
      setMaskedEmail(decodeURIComponent(masked_email));
    }
  }, []);

  async function resetMFAMethod() {
    if (email) {
      setDisableButton(true);
      let data = { email: email },
        url = '/profiles/change-mfa/';
      await axios
        .post(url, data)
        .then((res) => {
          if (res.status === 200) {
            setIsMfaReset(true);
          }
          setTimeout(() => {
            setDisableButton(false);
          }, 1000);
        })
        .catch((err) => {
          let res = err.response;
          if (res.status === 400) {
            setIsMfaReset(false);
            toast.error(res.data.detail, {});
          }
          setTimeout(() => {
            setDisableButton(false);
          }, 1000);
        });
    }
  }

  return (
    <>
      <div className="loginscreen">
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <Root className={classes.paper + ' white-form-div'}>
            <Avatar className={classes.avatar + ' avatar-logo'}>
              <img alt="vCISO" className="logo" src={SP360Logo} />
            </Avatar>
            <Typography component="h3" variant="h5">
              Change MFA method
            </Typography>
            <form
              className={classes.form}
              onSubmit={(event) => {
                event.preventDefault();
                resetMFAMethod();
              }}
            >
              {isMfaReset === false ? (
                <>
                  <Typography variant="body2" color="textPrimary" align="left">
                    {'Change MFA authenticator from OTP to Email (' +
                      maskedEmail +
                      ')?'}
                  </Typography>
                  <Button
                    type="submit"
                    disabled={disableButton}
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                  >
                    Confirm
                  </Button>
                </>
              ) : (
                <p> We have reset the MFA authentication method to email.</p>
              )}
              <Grid container>
                <Grid item xs>
                  <Button
                    type="button"
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                    onClick={() => {
                      redirectToLogin();
                    }}
                  >
                    <i
                      className="fa fa-arrow-left"
                      style={{ marginRight: '10px' }}
                      i
                    />
                    Login
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Root>
          <Box mt={8}>
            <Typography
              variant="body2"
              style={{ color: 'white' }}
              align="center"
            >
              {'Copyright © '}
              <Link color="inherit" href="/">
                SecurePoint 360
              </Link>{' '}
              {new Date().getFullYear()}
              {'.'}
            </Typography>
          </Box>
        </Container>
      </div>
      {renderNotification()}
    </>
  );
}

export default ChangeMFA;
